module.exports = __webpack_public_path__ + "img/showcase-cards-en-ca.d426051d.jpg";